import {
    UPDATE_USER_SUCCESS,
    UPDATE_USER_FAIL,
    API_ACCOUNT_SUCCESS,
    API_ACCOUNT_FAIL,
    GENERATE_TOKEN_SUCCESS,
    GENERATE_TOKEN_FAIL,
    API_PROCESS_TRANSACTION_SUCCESS,
    API_PROCESS_TRANSACTION_FAIL,
} from "../Actions/types";
  
import Cookies from 'js-cookie';

const token = Cookies.get("JWToken");

const initialState = token
  ? { isLoggedIn: true }
  : { isLoggedIn: false };
  
  export default function (state = initialState, action) {
    //const { type, payload } = action;
    const { type } = action;
    switch (type) {
        case UPDATE_USER_SUCCESS:
          return {
            ...state,
          };
        case UPDATE_USER_FAIL:
          return {
            ...state,
          };
        
        case API_ACCOUNT_SUCCESS:
          return {
            ...state,
           };
        case API_ACCOUNT_FAIL:
          return {
            ...state,
          };
        case GENERATE_TOKEN_SUCCESS:
          return {
            ...state,
          };
        case GENERATE_TOKEN_FAIL:
          return {
            ...state,
          };
        case API_PROCESS_TRANSACTION_SUCCESS:
          return {
            ...state,
          }
        case API_PROCESS_TRANSACTION_FAIL:
          return {
            ...state,
          }
      default:
        return state;
    }
  }